import React from 'react'

const Loading = () => (
    <div className="animate-pulse">
        <div className="m-2 w-11/14 h-40 bg-blue-100 dark:bg-gray-700 border rounded">

        </div>
    </div>

)

export default Loading